export default __webpack_public_path__ + "static/media/image-59.b4034bba.png";